import { render } from "./CargoImportSettingsInfoDialog.vue?vue&type=template&id=c85eb79c&ts=true"
import script from "./CargoImportSettingsInfoDialog.vue?vue&type=script&lang=ts"
export * from "./CargoImportSettingsInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__